export default __webpack_public_path__ + "assets/logos/5b9be21499c9296487ad59f16daa248d.png";